import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {EncryptDecryptService} from "../services/encrypt-decrypt.service";
import {HttpClient} from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {EditReponsePjComponent} from "../edit-reponse-pj/edit-reponse-pj.component";
import {DialogPjComponent} from "../dialog-pj/dialog-pj.component";

@Component({
  selector: 'app-reponse-historique',
  templateUrl: './reponse-historique.component.html',
  styleUrls: ['./reponse-historique.component.css']
})
export class ReponseHistoriqueComponent implements OnInit {

  apikey: string;
  user: any;
  jsonData: string;
  urlviewer: string;
  urlviewerCL: string;

  public reponses: Reponse[] = [];

  show: boolean = false;

  public selected: string;

  constructor(public dialog: MatDialog, public changeDetectorRefs: ChangeDetectorRef, private encdec: EncryptDecryptService, private http: HttpClient, private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('currentUser'));
    this.apikey = localStorage.getItem('apikey');
    this.getCandidateInfos();

  }

  getCandidateInfos(){
    this.http.get('https://api.sitederecrutement.com/Home/getcandidate?apikey=' + this.apikey + '&login=' + this.user.candidat_api, { responseType: "text" }).subscribe(
      (result) => {
        this.jsonData = this.encdec.getDecrypt( result);
        this.reponses = JSON.parse(this.jsonData).reponses;
        let https = this.http;
        let encdecb = this.encdec;
        this.reponses.forEach(function (x) {
          https.get('https://api.sitederecrutement.com/Home/GetAnnonce?apikey=' + localStorage.getItem('apikey') + '&id=' + x.idannonce, { responseType: "text" }).subscribe(result => {
            if (result.includes('{Error :')) {
              let json = JSON.parse(result);
            }
            else {
              const obj = JSON.parse(encdecb.getDecrypt( result).replace('emp_', ''));
              x.emp_intitule = obj.intitule;
            }
          }, error => console.error(error));
        });
      }
    );
  }

  openDialogEdit() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = 'custom-modalbox';

    const dialogRef = this.dialog.open(EditReponsePjComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(
      () => {
        this.changeDetectorRefs.detectChanges();
        this.getCandidateInfos();
      }
    )
  }

  openDialogViewPj(data: any, select: any) {
    //console.log('1ere data ' + data)
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.height = '600px';
    dialogConfig.width = '900px';
    dialogConfig.data = {url: data, select: select};

    const dialogRef = this.dialog.open(DialogPjComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(
      () => {
        this.changeDetectorRefs.detectChanges();
        this.selected = '';
      }
    )
  }

  arrayOne(n: number): any[] {
    return Array(n);
  }

  onClick(event) {
    this.selected = event;
  }

  onClear(){
    this.selected = '';
  }

}

interface Reponse {
  idcandidat: string;
  repform_date: string;
  idannonce: number;
  repform_source: string;
  repform_piece_jointe1: string;
  repform_piece_jointe2: string;
  repform_pj1_nom: string;
  repform_pj2_nom: string;
  repform_langue: string;
  emp_intitule: string;
}
